import React from 'react';
import { NavLink } from 'react-router-dom';
import {history} from '../routers/AppRouter';

const MobileNav = () => (
  <div className="MobileNav">
    <div>
        <NavLink exact={true} to={{pathname: '/', state: { prevPath: history.location.pathname }}}>
            <span className="icon-home"></span>
            <p>Home</p>
        </NavLink>
    </div>
    <div>
        <NavLink to={{pathname: '/about', state: { prevPath: history.location.pathname }}}>
            <span className="icon-info"></span>
            <p>About</p>
        </NavLink>
    </div>
    <div>
        <NavLink to={{pathname: '/work', state: { prevPath: history.location.pathname }}}>
            <span className="icon-briefcase"></span>
            <p>Work</p>
        </NavLink>
    </div>
    <div>
        <NavLink to={{pathname: '/contact', state: { prevPath: history.location.pathname }}}>
            <span className="icon-envelope"></span>
            <p>Contact</p>
        </NavLink>
    </div>
  </div>
);

export default MobileNav;


// WEBPACK FOOTER //
// ./src/components/MobileNav.js